import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';


const QRCode = require('qrcode.react');

const getRouteOrders = (props) => {
  const { routestops, orders } = props;

  if (!orders.length) {
    return [];
  }

  return orders.asMutable().filter(order => routestops.includes(order.id));
};


function convertAddressToGoogleMapsString(address) {
  return (address.companyName || '').concat(' ', address.street || '', ' ', address.zip || '', ' ', address.city || '');
}

const routeLink = (orders) => {
  const destinationAddress = orders.pop().address;
  const waypoints = orders.flatMap(order => convertAddressToGoogleMapsString(order.address));
  return `https://www.google.com/maps/dir/?api=1&destination=${convertAddressToGoogleMapsString(destinationAddress)}&waypoints=${waypoints.join('|')}&force_app_breakout=1`;
};

function renderActions(props) {
  const { classes, onClose } = props;

  const backButton = (
    <Button
      color="primary"
      onClick={onClose}
    >
      Zurück
    </Button>
  );
  const orders = getRouteOrders(props);
  if (!orders.length) {
    return backButton;
  }

  return (
    <>
      {backButton}
      <a className={classes.link} href={routeLink(orders)} target="_blank" rel="noopener noreferrer">
        <Button
          color="primary"
          onClick={() => { onClose(); }}
        >
          Maps öffnen
        </Button>
      </a>
    </>
  );
}

function renderRouting(props) {
  if (props.orders.length === 0) {
    return null;
  }

  const { classes } = props;

  const orders = getRouteOrders(props);

  if (orders.length === 0) {
    return (
      <p>Es muss mindestens eine Bestellung der Route zugeordnet sein!</p>
    );
  }

  return (
    <div className={classes.routeactionsContainer}>
      <QRCode
        value={routeLink(orders)}
        renderAs="svg"
      />
    </div>
  );
}

function RouteDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Dialog
      fullScreen={fullScreen}
      classes={{ paper: 'printDialog' }}
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Route</DialogTitle>
      <DialogContent>
        {renderRouting(props)}
      </DialogContent>
      <DialogActions>
        {renderActions(props)}
      </DialogActions>
    </Dialog>
  );
}

const styles = theme => ({
  routeactionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    padding: '2px',
  },
  link: {
    textDecoration: 'none',
  },
});


RouteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  routestops: PropTypes.array.isRequired,
  orders: PropTypes.array.isRequired,
};

RouteDialog.defaultProps = {
};


export default withStyles(styles)(RouteDialog);

